import { logoGreen } from 'images';
import { Link } from 'react-router-dom';

import { IMPERSONATION_BANNER_HEIGHT, useImpersonationSessions } from '@hooks/impersonation';
import MenuIcon from '@mui/icons-material/Menu';
import { AppBar, Box, IconButton, Toolbar, useMediaQuery, useTheme } from '@mui/material';

import { HotelChainSelectorMobile } from '../components/hotel-chain-selector/index.js';
import { HotelSelectorMobile } from '../components/hotel-selector/index.js';

import { NotificationBell } from './notifications/index.js';
import { UserMenuWithNotifications } from './user-menu/index.js';

interface HeaderMobileProps {
  onOpenSidebar: () => void;
}

export function HeaderMobile({ onOpenSidebar }: HeaderMobileProps) {
  const { isImpersonating } = useImpersonationSessions();
  const theme = useTheme();
  const isPhone = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <AppBar
      elevation={0}
      position="fixed"
      sx={{
        bgcolor: isImpersonating ? 'error.lighter' : 'background.paper',
        color: isImpersonating ? 'error.darker' : 'text.primary',
        borderBottom: isImpersonating ? 2 : 1,
        borderColor: isImpersonating ? 'error.main' : 'divider',
        top: isImpersonating ? IMPERSONATION_BANNER_HEIGHT : 0,
        transition: 'top 0.2s ease',
      }}
    >
      <Toolbar sx={{ gap: 1.5, px: { xs: 2 } }}>
        <IconButton
          data-testid="mobile-header-menu-button"
          edge="start"
          sx={{ color: 'inherit' }}
          onClick={onOpenSidebar}
        >
          <MenuIcon />
        </IconButton>

        {!isPhone && (
          <Link style={{ display: 'flex', flexShrink: 0 }} to="/">
            <Box
              alt="logo"
              component="img"
              src={logoGreen}
              sx={{ width: 110, height: 'auto', display: 'block' }}
            />
          </Link>
        )}

        <Box sx={{ flexGrow: 1 }} />

        <HotelSelectorMobile />
        <HotelChainSelectorMobile />

        {!isPhone && <NotificationBell />}
        <UserMenuWithNotifications withNotifications={isPhone} />
      </Toolbar>
    </AppBar>
  );
}
